import { render, staticRenderFns } from "./SetTlementReportSuperAdmin.vue?vue&type=template&id=0b754133&"
import script from "./SetTlementReportSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./SetTlementReportSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports